<template>
    <div>
        <b-sidebar id="search-sidebar" title="Search" v-model="$root.search_sidebar" right shadow>
            <b-container>
                <b-row>
                    <b-col>
                        <b-form>
                            <b-form-input id="inline-form-input-name " v-model="search" :value="search" class="mb-2" placeholder="IMEI No. / FP No. / Mobile No."></b-form-input>
                            <b-button variant="dark" class="float-right" pill @click="searchIMEI()">Search</b-button>
                        </b-form>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="mt-3">
                        <b-table-simple hover small caption-top responsive>
                            <b-thead head-variant="dark">
                                <b-tr>
                                    <b-th>Parameters</b-th>
                                    <b-th>Value</b-th>
                                </b-tr>
                            </b-thead>
                            <b-tbody>
                                <b-tr>
                                    <b-td>ULB</b-td>
                                    <b-td><b-link :href="'/devices/'+result.areacode">{{result.ulb_title}}</b-link></b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td>Zone</b-td>
                                    <b-td>{{result.zone_title}}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td>FP No.</b-td>
                                    <b-td>{{result.feeder_pillar_no}}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td>IMEI No.</b-td>
                                    <b-td><b-link :href="'/device-data/'+result.imei_no">{{result.imei_no}}</b-link></b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td>Mobile No.</b-td>
                                    <b-td>{{result.mobile_no}}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td>Meter No.</b-td>
                                    <b-td>{{result.device_no}}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td>Sys Meter No.</b-td>
                                    <b-td>{{result.sys_meter_no}}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td>State ID</b-td>
                                    <b-td variant="success">{{result.state_id}}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td>Location</b-td>
                                    <b-td>{{result.location}}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td>Longitude</b-td>
                                    <b-td>{{result.location_lng}}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td>Latitude</b-td>
                                    <b-td>{{result.location_lat}}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td>Supply</b-td>
                                    <b-td>
                                        <img src="../assets/power-off.svg" v-if="result.datalength == 59" style="max-width:20px; max-height:20px;">
										<img src="../assets/power-on.svg" v-else style="max-width:20px; max-height:20px;">
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td>Output</b-td>
                                    <b-td>{{(result.output_status == 0)?'OFF':'ON'}}</b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td>Door</b-td>
                                    <b-td>
                                        <b-badge pill variant="success" v-if="result.door_status == 0">CLOSED</b-badge>
                                        <b-badge pill variant="danger" v-else>OPENED</b-badge>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td>Network</b-td>
                                    <b-td>
                                        <b-link :href="'/device-fault/'+result.imei_no" v-if="connection_status == 2"><div><b-badge pill variant="warning">METER FAULT</b-badge></div></b-link>
                                        <b-badge pill variant="danger" v-else-if="connection_status == 0">DISCONNECTED</b-badge>
                                        <b-badge pill variant="success" v-else>CONNECTED</b-badge>
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td>DATA Len</b-td>
                                    <b-td>{{result.datalength}}
                                    </b-td>
                                </b-tr>
                                <b-tr>
                                    <b-td>Last Time</b-td>
                                    <b-td>{{last_update_time}}</b-td>
                                </b-tr>
                            </b-tbody>
                        </b-table-simple>
                    </b-col>
                </b-row>
            </b-container>
        </b-sidebar>
    </div>
</template>

<script>
export default {
  name: 'Search',
  props: {
    msg: String,
    search:String,
  },
  data() {
		var self = this;
		
		return{
			loading: false, 
            last_sync_time: '',
            last_update_time: '',
			zoneOptions: [],
			networkfilter: -1,
            powerfilter: -1,

            searchUrl: self.$session.get('apiurl')+'aligarhapi/search-device',

            connection_status: '',
           // search:'',
            search_status: 0,
            result: {},
        }
    },
    methods: {
        searchIMEI(){
            var self = this;
            
            if(self.search.length > 2 && self.search.length <= 15){
                self.loading = true;
                self.search_status = 0;

                self.axios.post(self.searchUrl, {
                    accesskey: self.$session.get('access_key'),
                    imei_no: self.search
                })
                .then(function (response) {
                    self.loading = false;
                    if(response.data.error == 0){
						self.result = response.data.result;
						if(self.result.length == 0){
							self.search_status = 0;
							return;
						}
                        self.search_status = 1;

                        self.last_update_time = '';
                        if(self.result.update_time == "" || self.result.update_time == "00-00-0000 00:00:00"){
							self.last_update_time = '-n/a-';
						}
                        self.last_update_time = self.$moment(self.result.update_time).format('DD-MM-YYYY HH:mm:ss');
                        
                        self.network_status = 0;

                        var curdatetime = self.$moment();
						var conn_status = 1;
						var dbdatetime = '';
						var duration = '';
						var minutes = '';
                        if(self.result.update_time != ""){
							dbdatetime = self.$moment(self.result.update_time);

							if(curdatetime > dbdatetime){
								duration = self.$moment.duration(curdatetime.diff(dbdatetime));
							}else{
								duration = self.$moment.duration(dbdatetime.diff(curdatetime));
                            }
							minutes = duration.asMinutes();
							
							if(minutes < self.$root.disconnection_time){
								conn_status = 1;
							}else{
								conn_status = 0;
							}
						}else{
							conn_status = 0;
						}
						self.connection_status = conn_status;
                        if(self.result.datalength != 59 && self.result.datalength != 210){
							self.connection_status = 2;
						}

                        var msg = 'Search Completed!';
                        self.$bvToast.toast(msg, {
                            title: 'Delete',
                            toaster: 'b-toaster-bottom-right',
                            autoHideDelay: 5000,
                            variant: 'warning',
                            solid: true,
                            appendToast: true
                        });
                    }else{
                        self.search_status = 0;
                    }
                })
                .catch(function (error) {
                    alert(error);
                });
            }
            
        },
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.footer{
  font-size: 10px;
}
</style>
